import { render, staticRenderFns } from "./LookupCustomerCode.vue?vue&type=template&id=b0b2c274&scoped=true"
import script from "./LookupCustomerCode.vue?vue&type=script&lang=ts"
export * from "./LookupCustomerCode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b2c274",
  null
  
)

export default component.exports